import { render } from "./RcDropdownSeparator.vue?vue&type=template&id=9c5e4140"
const script = {}

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__